import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Salvar Lançamento", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_5 = {
  key: 0,
  class: "ant-col ant-col-xs-6 ant-col-xl-6"
}
const _hoisted_6 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_7 = { class: "ant-col ant-col-xs-14 ant-col-xl-14" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = {
  key: 0,
  class: "ant-col ant-col-xs-6 ant-col-xl-6"
}
const _hoisted_12 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "N.Identificação"
}, "N.Identificação", -1)
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_detalhes_abertura_caixa = _resolveComponent("detalhes-abertura-caixa")!
  const _component_selecionar_generico = _resolveComponent("selecionar-generico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_movimento_financeiro = _resolveComponent("selecionar-tipo-movimento-financeiro")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_marcador_movimento_financeiro = _resolveComponent("selecionar-marcador-movimento-financeiro")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_movimento_financeiro_centro_custo = _resolveComponent("movimento-financeiro-centro-custo")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_movimento_financeiro_anexo = _resolveComponent("movimento-financeiro-anexo")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Movimento de Caixa",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 900,
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile?'scroll-modal ss-modal-financeiro':'ss-modal-financeiro'
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.state.editavel)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
            }, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 15 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_detalhes_abertura_caixa, {
                empresa: _ctx.props.empresa,
                abertura: _ctx.props.abertura
              }, null, 8, ["empresa", "abertura"]),
              (_ctx.state.tipoLancamento !== 3)
                ? (_openBlock(), _createBlock(_component_card, {
                    key: 0,
                    titulo: "DADOS DO LANÇAMENTO"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo de Lançamento",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_generico, {
                                itens: _ctx.state.tiposLancamento,
                                valor: _ctx.state.tipoLancamento,
                                "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.tipoLancamento) = $event)),
                                limparSelecao: false
                              }, null, 8, ["itens", "valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        (_ctx.state.tipoLancamento == 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_a_form_item, {
                                label: "Tipo de Movimento",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_tipo_movimento_financeiro, {
                                    valor: _ctx.state.movimento.tipoMovimento,
                                    "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.movimento.tipoMovimento) = $event))
                                  }, null, 8, ["valor"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.movimento.valor,
                                "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.movimento.valor) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                empresas: [_ctx.props.empresa],
                                "codigo-selecionado": _ctx.state.movimento.codigoPlanoContaCategoria,
                                "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.movimento.codigoPlanoContaCategoria) = $event))
                              }, null, 8, ["empresas", "codigo-selecionado"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_a_form_item, {
                            label: "Observações",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.movimento.observacoes) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.movimento.observacoes]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_card, { titulo: "DADOS DO LANÇAMENTO" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          (_ctx.props.codigoMovimento === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_a_form_item, {
                                  label: "Tipo de Lançamento",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_generico, {
                                      limparSelecao: false,
                                      itens: _ctx.state.tiposLancamento,
                                      valor: _ctx.state.tipoLancamento,
                                      "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.tipoLancamento) = $event)),
                                      disabled: !_ctx.state.editavel
                                    }, null, 8, ["itens", "valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.props.codigoMovimento === 0 ? 'ant-col ant-col-xs-4 ant-col-xl-4' : 'ant-col ant-col-xs-10 ant-col-xl-10')
                          }, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipo de Movimento",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_movimento_financeiro, {
                                  valor: _ctx.state.movimento.tipoMovimento,
                                  "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.movimento.tipoMovimento) = $event)),
                                  disabled: !_ctx.state.editavel
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ], 2),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                              label: _withCtx(() => [
                                _hoisted_13,
                                _createVNode(_component_a_tooltip, {
                                  placement: "top",
                                  title: "Informe aqui o número do documento, título ou qualquer outra numeração que você deseje identificar este movimento."
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_icone, {
                                      class: "ss-icone-informacao-campo",
                                      nome: "informacao-campo"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.movimento.identificadorMovimento) = $event)),
                                  disabled: !_ctx.state.editavel
                                }, null, 8, _hoisted_14), [
                                  [_vModelText, _ctx.state.movimento.identificadorMovimento]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_a_form_item, {
                              label: "Valor",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  valor: _ctx.state.movimento.valor,
                                  "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.movimento.valor) = $event)),
                                  disabled: !_ctx.state.editavel
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "1",
                          tab: "DETALHES"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_card, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Descrição",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "ant-input",
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.movimento.descricao) = $event)),
                                          placeholder: "Digite aqui detalhes e informações importantes deste movimento",
                                          disabled: !_ctx.state.editavel
                                        }, null, 8, _hoisted_18), [
                                          [_vModelText, _ctx.state.movimento.descricao]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_19, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Pessoa",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_pessoa, {
                                          codigoSelecionado: _ctx.state.movimento.codigoPessoa,
                                          "onUpdate:codigoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.movimento.codigoPessoa) = $event)),
                                          empresas: [_ctx.state.movimento.codigoEmpresa],
                                          apresentarRelacoes: true,
                                          disabled: !_ctx.state.editavel,
                                          recursoOrigem: _ctx.telaBase.identificadorRecurso
                                        }, null, 8, ["codigoSelecionado", "empresas", "disabled", "recursoOrigem"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Categoria",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_categoria_plano_conta, {
                                          codigoSelecionado: _ctx.state.movimento.codigoPlanoContaCategoria,
                                          "onUpdate:codigoSelecionado": [
                                            _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.movimento.codigoPlanoContaCategoria) = $event)),
                                            _cache[13] || (_cache[13] = ($event: any) => (_ctx.obterCentrosCustoContaContabil()))
                                          ],
                                          empresas: [_ctx.state.movimento.codigoEmpresa],
                                          disabled: !_ctx.state.editavel
                                        }, null, 8, ["codigoSelecionado", "empresas", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Marcadores",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_marcador_movimento_financeiro, {
                                          marcadoresSelecionados: _ctx.state.marcadores,
                                          "onUpdate:marcadoresSelecionados": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                                          disabled: !_ctx.state.editavel
                                        }, null, 8, ["marcadoresSelecionados", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "2",
                          tab: "OBSERVAÇÕES"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_card, { titulo: " " }, {
                              default: _withCtx(() => [
                                _createVNode(_component_editor_html, {
                                  value: _ctx.state.movimento.observacoes,
                                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.movimento.observacoes) = $event)),
                                  disabled: !_ctx.state.editavel
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "3",
                          tab: "CENTRO DE CUSTO"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_skeleton, {
                              loading: _ctx.state.carregandoCentrosCusto
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_movimento_financeiro_centro_custo, {
                                  visivel: _ctx.modalBase.computedVisivel,
                                  valor: _ctx.state.movimento.valor,
                                  codigoRegistro: _ctx.state.movimento.codigo,
                                  centrosCusto: _ctx.state.centrosCusto,
                                  "onUpdate:centrosCusto": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.centrosCusto) = $event)),
                                  editavel: _ctx.state.editavel
                                }, null, 8, ["visivel", "valor", "codigoRegistro", "centrosCusto", "editavel"])
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "4",
                          tab: "ANEXOS"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_skeleton, {
                              loading: _ctx.state.carregandoAnexos
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_movimento_financeiro_anexo, {
                                  empresa: _ctx.state.movimento.codigoEmpresa,
                                  codigoMovimentoFinanceiro: _ctx.state.movimento.codigo,
                                  anexos: _ctx.state.movimento.anexos,
                                  "onUpdate:anexos": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.movimento.anexos) = $event)),
                                  editavel: _ctx.state.editavel
                                }, null, 8, ["empresa", "codigoMovimentoFinanceiro", "anexos", "editavel"])
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}